(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kora-50k-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.k50:not([data-ready])').forEach((root) => {
      root.dataset.ready = 'true';
      const start = new Date(root.dataset.countdownStart).getTime();
      const end = new Date(root.dataset.countdownEnd).getTime();
      const label = root.querySelector('[data-k50-timer-label]');
      const days = root.querySelector('[data-k50-days]');
      const hours = root.querySelector('[data-k50-hours]');
      const minutes = root.querySelector('[data-k50-minutes]');
      const seconds = root.querySelector('[data-k50-seconds]');
      const heroCopy = root.querySelector('[data-k50-hero-copy]');
      const stickyTime = root.querySelector('[data-k50-sticky-time]');
      const promoActions = root.querySelectorAll('[data-k50-promo-action]');
      promoActions.forEach((action) => { action.dataset.activeHref = action.getAttribute('href'); });
      promoActions.forEach((action) => {
        if (!action.dataset.cartAdd) return;
        action.addEventListener('click', async (event) => {
          if (action.getAttribute('aria-disabled') === 'true') return;
          event.preventDefault();
          const originalLabel = action.textContent;
          const items = action.dataset.cartAdd.split(',').map((item) => {
            const [id, quantity] = item.split(':');
            return { id: Number(id), quantity: Number(quantity) };
          });
          action.textContent = 'Agregando…';
          action.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch(root.dataset.cartAddUrl, {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) throw new Error('No se pudo armar el carrito');
            action.textContent = 'Listo ✓';
            window.location.assign(action.dataset.afterAdd || root.dataset.cartUrl);
          } catch (error) {
            action.textContent = originalLabel;
            action.removeAttribute('aria-busy');
            window.location.assign(action.dataset.activeHref);
          }
        });
      });
      const confetti = root.querySelector('[data-k50-confetti]');
      if (confetti && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const context = confetti.getContext('2d');
        const ratio = Math.min(window.devicePixelRatio || 1, 2);
        const width = window.innerWidth;
        const height = window.innerHeight;
        confetti.width = width * ratio;
        confetti.height = height * ratio;
        context.scale(ratio, ratio);
        const colors = ['#ffffff', '#f5f1e9', '#151515', '#671018'];
        const pieces = Array.from({ length: 58 }, () => ({
          x: Math.random() * width,
          y: -20 - Math.random() * 220,
          width: 5 + Math.random() * 6,
          height: 8 + Math.random() * 9,
          speedX: -1.8 + Math.random() * 3.6,
          speedY: 3.2 + Math.random() * 3.8,
          rotation: Math.random() * Math.PI,
          spin: -0.1 + Math.random() * 0.2,
          color: colors[Math.floor(Math.random() * colors.length)]
        }));
        const confettiStart = performance.now();
        const drawConfetti = (time) => {
          context.clearRect(0, 0, width, height);
          pieces.forEach((piece) => {
            piece.x += piece.speedX;
            piece.y += piece.speedY;
            piece.rotation += piece.spin;
            context.save();
            context.translate(piece.x, piece.y);
            context.rotate(piece.rotation);
            context.fillStyle = piece.color;
            context.fillRect(-piece.width / 2, -piece.height / 2, piece.width, piece.height);
            context.restore();
          });
          if (time - confettiStart < 1900) {
            window.requestAnimationFrame(drawConfetti);
          } else {
            confetti.remove();
          }
        };
        window.requestAnimationFrame(drawConfetti);
      }
      const pad = (value) => String(value).padStart(2, '0');
      const tick = () => {
        const now = Date.now();
        let target = start;
        label.textContent = 'EMPIEZA EN';
        let state = 'before';
        if (now >= start && now < end) { target = end; state = 'active'; label.textContent = 'TERMINA EN'; }
        if (now >= end) { target = now; state = 'ended'; label.textContent = 'LA PROMO FINALIZÓ'; }
        promoActions.forEach((action) => {
          if (state !== 'ended') {
            action.setAttribute('href', action.dataset.activeHref);
            action.removeAttribute('aria-disabled');
            action.textContent = state === 'before' ? action.dataset.beforeLabel : action.dataset.activeLabel;
          } else {
            action.removeAttribute('href');
            action.setAttribute('aria-disabled', 'true');
            action.textContent = 'Promoción finalizada';
          }
        });
        if (state === 'active') {
          heroCopy.innerHTML = 'Hoy, de <strong>15:00 a 20:00</strong>. Elegí tu promo y pagá por <strong>transferencia</strong>.';
          stickyTime.textContent = 'AHORA · HASTA LAS 20 HS';
        } else if (state === 'ended') {
          heroCopy.innerHTML = 'El Especial 50.000 terminó. <strong>Gracias por festejar con nosotros.</strong>';
          stickyTime.textContent = 'PROMOCIÓN FINALIZADA';
        }
        const remaining = Math.max(0, target - now);
        days.textContent = pad(Math.floor(remaining / 86400000));
        hours.textContent = pad(Math.floor((remaining % 86400000) / 3600000));
        minutes.textContent = pad(Math.floor((remaining % 3600000) / 60000));
        seconds.textContent = pad(Math.floor((remaining % 60000) / 1000));
      };
      tick();
      window.setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
